import React from "react"

/**
 * Red asterisk appended to a required field's label. Kept as a shared component
 * so every metric config form flags required inputs identically and the marker
 * stays in sync with the save-time required-field validation.
 */
export const RequiredMarker: React.FC = () => (
  <span className="text-coval-danger-text" aria-hidden="true">
    {" "}
    *
  </span>
)
